import { useSyncExternalStore } from "react";
export interface WindowDimensions {
  width: number;
  height: number;
}
const SSR_SNAPSHOT: WindowDimensions = {
  width: 0,
  height: 0
};
let cache: WindowDimensions = SSR_SNAPSHOT;
function subscribe(callback: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("resize", callback);
  return () => window.removeEventListener("resize", callback);
}
function getSnapshot(): WindowDimensions {
  const w = window.innerWidth;
  const h = window.innerHeight;
  if (w === cache.width && h === cache.height) return cache;
  return cache = {
    width: w,
    height: h
  };
}
export function useWindowDimensions() {
  return useSyncExternalStore(subscribe, getSnapshot, _temp);
}
function _temp() {
  return SSR_SNAPSHOT;
}